import { defineMessages } from 'react-intl';

const messages = defineMessages({
  justNow: {
    id: '9xr7/i',
    defaultMessage: 'Just now',
    description: 'Relative time label for notifications created less than a minute ago',
  },
  minutesAgo: {
    id: 'yVDXMH',
    defaultMessage: '{count, plural, one {# min ago} other {# mins ago}}',
    description: 'Relative time label for notifications created minutes ago',
  },
  hoursAgo: {
    id: '+M9w7U',
    defaultMessage: '{count, plural, one {# hr ago} other {# hrs ago}}',
    description: 'Relative time label for notifications created hours ago',
  },
  daysAgo: {
    id: 'r1u84f',
    defaultMessage: '{count, plural, one {# day ago} other {# days ago}}',
    description: 'Relative time label for notifications created days ago',
  },
  downloadExport: {
    id: 'NcBtg3',
    defaultMessage: 'Download File',
    description: 'Action button label for downloading an export file from a notification',
  },
  viewProducts: {
    id: 'IKeHnJ',
    defaultMessage: 'View Products',
    description: 'Navigation button label on product import notifications',
  },
  viewOrders: {
    id: '+nIYXI',
    defaultMessage: 'View Orders',
    description: 'Navigation button label on order import notifications',
  },
  viewCustomers: {
    id: 'azifKF',
    defaultMessage: 'View Customers',
    description: 'Navigation button label on customer import notifications',
  },
  viewInventory: {
    id: 'fi23nd',
    defaultMessage: 'View Inventory',
    description: 'Navigation button label on inventory import notifications',
  },
});

export { messages };
